import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useCallInvitationPresenter } from './CallInvitation.presenter';
import { ViewType } from './CallInvitation.types';
import { JoinBlock } from './JoinBlock/JoinBlock';
import { NameBlock } from './NameBlock/NameBlock';

export const CallInvitation: FC = observer(() => {
  const presenter = useCallInvitationPresenter();

  return (
    <>
      {presenter.currentView === ViewType.JoinView && <JoinBlock setView={presenter.setView} />}
      {presenter.currentView === ViewType.NameView && <NameBlock setView={presenter.setView} />}
    </>
  );
});
